import { __read } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { createContext, useCallback, useMemo } from 'react';
import { EXTERNAL_URLS, PAGE_NAMES } from '../components/SelectionCalculator/constants.js';
import { emit } from './helpers.js';

var AnalyticsContext = createContext(null);
var AnalyticsProvider = function (props) {
    var _a = props.enableAnalytics, enableAnalytics = _a === void 0 ? false : _a, customEventLabelPage = props.eventLabelPage, children = props.children;
    var pushEvent = useCallback(function (event) {
        if (!enableAnalytics)
            return;
        emit(event, enableAnalytics === 'logs');
    }, [enableAnalytics]);
    var eventLabelPage = useMemo(function () {
        if (customEventLabelPage) {
            return customEventLabelPage;
        }
        var currentPath = (typeof window !== 'undefined' && window.location.pathname) || undefined;
        var page = Object.entries(EXTERNAL_URLS).find(function (_a) {
            var _b = __read(_a, 2); _b[0]; var paths = _b[1];
            return paths.includes(currentPath || '');
        });
        if (!page) {
            return 'unknown page';
        }
        return PAGE_NAMES[page[0]];
    }, [customEventLabelPage]);
    var value = useMemo(function () { return ({ pushEvent: pushEvent, eventLabelPage: eventLabelPage }); }, [pushEvent, eventLabelPage]);
    return jsx(AnalyticsContext.Provider, { value: value, children: children });
};

export { AnalyticsContext, AnalyticsProvider };
//# sourceMappingURL=context.js.map
